import { Chevrons } from '@renderer-ui-library/atoms'
import { BenefitCard, CmsMediaFile } from '@renderer-ui-library/molecules'
import { Typography } from '@renderer-ui-library/mui'
import { BlockWrapper } from '@renderer-ui-library/scaffolding/BlockWrapper/BlockWrapper'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import React, { useMemo } from 'react'
import { BlockProps } from '../BlockProps'
import { IBenefitsBlockData } from './IBenefitsBlockData'
import styles from './benefitsBlock.module.scss'

export const BenefitsBlock: React.FC<BlockProps<IBenefitsBlockData>> =
  React.memo(({ data }) => {
    const cards = useMemo(() => {
      return data.benefitCards.reduce<
        {
          headline: string
          description: string
          image: CmsMediaFile
          cta: string
        }[]
      >((list, current) => {
        if (current.image.data) {
          list.push({
            cta: current.cta,
            description: current.description,
            headline: current.headline,
            image: current.image.data,
          })
        }

        return list
      }, [])
    }, [data.benefitCards])

    return (
      <BlockWrapper blockData={data}>
        <div className={styles.titleWrapper}>
          <Chevrons />
          <Typography variant='h2'>{data.headline}</Typography>
        </div>
        <div>
          <Splide
            options={{
              arrows: true,
              pagination: true,
              perPage: 3,
              gap: '1rem',
              lazyLoad: true,
              classes: {
                pagination: `splide__pagination ${styles.pagination}`,
              },
              breakpoints: {
                768: {
                  perPage: 1,
                },
              },
            }}
          >
            {cards.map((card, i) => (
              <SplideSlide key={`${i}-${card.headline}`}>
                <BenefitCard
                  cta={card.cta}
                  description={card.description}
                  headline={card.headline}
                  image={card.image}
                />
              </SplideSlide>
            ))}
          </Splide>
        </div>
      </BlockWrapper>
    )
  })

BenefitsBlock.displayName = 'BenefitsBlock'
